// =======================
// BOOSTRAP
// =======================
import '../../node_modules/bootstrap/js/dist/alert';
import '../../node_modules/bootstrap/js/dist/button';
import '../../node_modules/bootstrap/js/dist/carousel';
import '../../node_modules/bootstrap/js/dist/collapse';
import '../../node_modules/bootstrap/js/dist/dropdown';
import '../../node_modules/bootstrap/js/dist/modal';
import '../../node_modules/bootstrap/js/dist/offcanvas';
import '../../node_modules/bootstrap/js/dist/popover';
import '../../node_modules/bootstrap/js/dist/scrollspy';
import '../../node_modules/bootstrap/js/dist/tab';
import '../../node_modules/bootstrap/js/dist/toast';
import '../../node_modules/bootstrap/js/dist/tooltip';

import './auth/lazyload.js'; // import LazyLoad for lazy loading images
import './auth/webpChecker.js' //
import './auth/aos.js'; // import AOS for animations on scroll
import './auth/swiper.js'; // import Swiper for carousels
//import './auth/fancyapps.js'; // import Fancyapps
import './auth/form.js'; // import form enhancements (tooltips, etc.)

import './auth/scroll.js'; // import scroll event listener to add 'scrolled' class to body
import './auth/hideComments.js'; // import script to hide comments in the DOM
import './auth/arrows.js'; // import script to handle arrow menu functionality
import './auth/navbar.js'; // import script to handle navbar functionality
import './auth/switchSoluzioni.js'; // import script to handle navbar functionality
import './auth/showHidePsw.js'; // import script to handle show/hide password functionality
import './auth/soluzione.js'; // import script to handle solution selection functionality
import './auth/showWaiting.js'; // import script to show the page loader on .show-waiting links and valid form submits
import './auth/checkSys.js'; // import script to handle check system functionality
import './auth/timerLettura.js'; // import script to handle check system functionality
import './auth/preloadArticleAjax.js'; // import script to handle check system functionality
import './auth/speechSynthesis.js'; // import script to handle text-to-speech functionality
import './auth/sortFilter.js'; // import script to handle sort filter functionality
import './auth/rangeFilter.js'; // import script to handle range filter functionality (price, surface, etc.)
import './auth/searchFilter.js'; // import script to handle search filter functionality
import './auth/tribunaleFilter.js'; // import script to handle tribunale filter functionality
import './auth/modalFilter.js'; // import script to handle modal filter functionality
import './auth/responsiveFilters.js'; // import script to handle responsive filters (move to modal when they don't fit)
import './auth/gestionePacchetti.js'; // import script to handle responsive filters (move to modal when they don't fit)